import { PriceComponent } from './price.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ PriceComponent });
